import { render, staticRenderFns } from "./TeamWorksList.vue?vue&type=template&id=387af0dc"
import script from "./TeamWorksList.vue?vue&type=script&lang=js"
export * from "./TeamWorksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports